import { generateKeys, generateLocalization } from '../utils';
import { companies } from './companies';
export const supportQuestions = generateLocalization('supportQuestions', generateKeys({
    accountQuestion: {
        label: 'I have a question about my account',
        value: 'accountQuestion',
        email: 'support',
        localization: { id: '', defaultMessage: '' },
        disabled: false,
    },
    depositQuestion: {
        label: 'I have a question about my deposit',
        value: 'depositQuestion',
        email: 'support',
        localization: { id: '', defaultMessage: '' },
        disabled: false,
    },
    technicalQuestion: {
        label: 'I have a technical problem',
        value: 'technicalQuestion',
        email: 'support',
        localization: { id: '', defaultMessage: '' },
        disabled: false,
    },
    dealingQuestion: {
        label: 'I have a question for my Account Manager/Dealing Room',
        value: 'dealingQuestion',
        email: 'support',
        localization: { id: '', defaultMessage: '' },
        disabled: false,
    },
    complaintQuestion: {
        label: 'I’d like to make a complaint',
        value: 'complaintQuestion',
        email: 'complaints',
        localization: { id: '', defaultMessage: '' },
        disabled: false,
    },
    affiliatesQuestion: {
        label: 'I have a question regarding the Partner Program',
        value: 'affiliatesQuestion',
        email: 'affiliates',
        localization: { id: '', defaultMessage: '' },
        blockedCompanies: [companies.bdSwiss.key, companies.swissMarkets.key, companies.swissMarketsVanuatu.key, companies.swissMarketsMauritius.key],
        disabled: false,
    },
    otherQuestion: {
        label: 'Other',
        value: 'otherQuestion',
        email: 'support',
        localization: { id: '', defaultMessage: '' },
        disabled: true,
    },
}));
